export default {
  address: ['user-input', 'map', 'informer', 'common/cottage-village-name'],
  'about-house': [
    'common/suburban-total-area',
    'common/floors-count-house',
    'common/bedrooms-count',
    'common/material-type-house',
    'house-condition',
    'common/build-year',
  ],
  'about-land': ['common/area-land', 'land-category', 'common/suburban-building-status'],
  facilities: [
    'common/wc-location-type',
    'common/wc-count',
    'common/drainage',
    'common/water',
    'common/gas',
    'common/heating-type-house',
    'common/has-electricity',
    'common/in-house-sale',
  ],
  'price-and-deal-terms': ['price', 'agent-bonus'],
};
